import { BaseContainerModel } from "../base-container.model";
import {
  bl_mkp_mst_item_event_Rowinterface,
  bl_mkp_mst_item_event_Rowclass,
} from "../../dbschema/index";

export class MkpItemEventContainerModel extends BaseContainerModel {
  bl_mkp_mst_item_event: bl_mkp_mst_item_event_Rowinterface =
    new bl_mkp_mst_item_event_Rowclass();
} 
